import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { JsonLdResource } from '@core/api/base';
import { ResourceCollection } from '@core/api/collection';
import { Pageable } from '@core/pagination/pageable';
import {HydraCollection} from "@core/api/hydra/hydra-collection";
import {ResourceCollectionFactory} from "@core/api/factory/resource-collection-factory";



@Injectable({
  providedIn: 'root'
})
export class PageableFactory {

  public static createFromCollectionStatic<T>(
    collection: ResourceCollection<JsonLdResource>,
    itemAdapter: Adapter<T>
  ):Pageable<T> {

    return new Pageable<T>(
      collection.items.map(itemAdapter.adapt.bind(itemAdapter)),
      collection.currentPage,
      collection.totalPages,
      collection.totalItems,
      collection.itemsPerPage,
      collection.view
    );
  }

  public static createFromHydraCollection<T>(
    hydraCollection: HydraCollection<any>,
    itemAdapter: Adapter<T>|null = null
  ):Pageable<T> {
    const collection = ResourceCollectionFactory.createFromHydraCollection(hydraCollection);

    return new Pageable<T>(
      itemAdapter ? collection.items.map(itemAdapter.adapt.bind(itemAdapter)) : collection.items,
      collection.currentPage,
      collection.totalPages,
      collection.totalItems,
      collection.itemsPerPage,
      collection.view
    );
  }
}
